import React from 'react';
import { Grid, Image, Item, Button, Placeholder } from 'semantic-ui-react';
import parse from 'html-react-parser';
//import { Link } from 'react-router-dom';
import { useState } from 'react';
import { /*useDispatch,*/ useSelector } from 'react-redux';
import Stars from '../../../app/common/elements/Stars';
import {
  // addToFavorites,
  //  removeFromFavorites,
  reportBrokenLink,
} from '../../../app/firestore/firestoreService';
//import { openModal } from '../../../app/common/modals/modalReducer';
import { toast } from 'react-toastify';
import ButtonLink from '../../../app/common/elements/ButtonLink';
import MicroData from '../../../app/common/elements/MicroData';
import { Fragment } from 'react';
import {
  asyncActionError,
  asyncActionFinish,
  asyncActionStart,
} from '../../../app/async/asyncReducer';

export default function ApplicationDetailedHeader({ application, photos }) {
  // const dispatch = useDispatch();
  const [mainPhoto, setMainPhoto] = useState();
  const [linkReported, setLinkReported] = useState(false);
  const { loading } = useSelector((state) => state.async);
  const showPhotos = true;
  //const { currentUser } = useSelector((state) => state.auth);
  //const [favorite, setFavorite] = useState(false);
  //const [hovered, setHovered] = useState(false);
  // const { favorites } = useSelector(
  //   (state) => state.profile.currentUserProfile
  // );

  function switchMainPhoto(photoURL) {
    setMainPhoto(photoURL);
  }

  // function handleAddToFavorites(favorite) {
  //   //setFavorite(!favorite);
  //   if (favorite) {
  //     removeFromFavorites(application.id, favorite);
  //   } else {
  //     addToFavorites(application);
  //   }
  // }

  // function openSuggestion() {
  //   dispatch(
  //     openModal({
  //       modalType: 'SuggestAnEdit',
  //       modalProps: application,
  //     })
  //   );
  // }

  function reportLink(appId) {
    try {
      if (!linkReported) {
        console.log('started');
        asyncActionStart();
        reportBrokenLink(appId);
        setLinkReported(true);
        asyncActionFinish();
      } else {
        toast.info('Thanks, we received your report.');
      }
    } catch (error) {
      toast.error(error);
      asyncActionError(error);
    }
  }

  let url;
  if (application?.affiliate_link !== '') {
    url = '/go/' + application.slug;
  } else {
    url = application.url;
    if (url.substring(0, 4) !== 'http') url = 'http://' + url;
  }

  //const favorite = favorites?.some((fav) => fav === application.id);

  return (
    <Fragment>
      <MicroData application={application} photos={photos} />
      <Grid>
        <Grid.Row>
          <Grid.Column computer={6} mobile={16}>
            {loading ? (
              <Placeholder>
                <Placeholder.Image square />
              </Placeholder>
            ) : (
              <Image
                src={
                  mainPhoto ||
                  application.photoURL ||
                  `https://images.shrinktheweb.com/xino.php?stwembed=1&stwaccesskeyid=6dbdf52c041d58b&stwsize=120x90&stwurl=${url}`
                }
                style={{ width: '100%' }}
                onError={(i) => (i.target.style.display = 'none')}
              />
            )}
            {showPhotos && photos && photos.length > 1 && (
              <Grid style={{ marginLeft: '0px', marginTop: '0px' }}>
                <Grid.Column width={2} style={{ margin: '2px', padding: 0 }}>
                  <Image
                    src={application.photoURL}
                    style={{ width: '100%' }}
                    onClick={() => switchMainPhoto(application.photoURL)}
                  />
                </Grid.Column>
                {photos
                  .filter((photo) => photo.url !== application.photoURL)
                  .map((photo) => (
                    <Grid.Column
                      width={2}
                      style={{ margin: '2px', padding: 0 }}
                      key={photo.id}
                    >
                      <Image
                        src={photo.url}
                        style={{ width: '100%' }}
                        onClick={() => switchMainPhoto(photo.url)}
                      />
                    </Grid.Column>
                  ))}
              </Grid>
            )}
          </Grid.Column>
          <Grid.Column computer={10} mobile={16}>
            <h1 className='appHeader'>
              {application.title}
              {/* <Button
                content='Edit Application'
                style={{ marginTop: 10 }}
                positive
                floated='right'
                as={Link}
                to={`/manage/${application?.id}`}
              />
              <div
                style={{
                  display: 'inline-block',
                  float: 'right',
                  minWidth: '250px',
                }}
              >
                <Icon
                  name={favorite ? 'heart' : 'heart outline'}
                  color='red'
                  // content='Add To Favorites'
                  // style={{ marginTop: 10 }}
                  // positive
                  floated='right'
                  // as={Link}
                  onClick={() => handleAddToFavorites(favorite)}
                  onMouseOver={() => setHovered(true)}
                  onMouseOut={() => setHovered(false)}
                  size='small'
                  title={
                    favorite ? 'Remove from favorites' : 'Add to favorites'
                  }
                />
                {hovered && (
                  <span
                    className='favorite-text'
                    style={{ fontSize: '0.5em', verticalAlign: 'middle' }}
                  >
                    {favorite ? 'Remove From Favorites' : 'Add To Favorites'}
                  </span>
                )}
              </div> */}
            </h1>

            <Item.Content style={{ fontSize: '0.9em' }}>
              Added By:{' '}
              {application?.author_name
                ? application.author_name === 'admin'
                  ? 'Language Learning Library'
                  : application.author_name
                : application.author === 'Gary McCann'
                ? 'Language Learning Library'
                : application.author}
              <br />
              User rating:{' '}
              {application.star_rating ? (
                <span>
                  <Stars starRating={application.star_rating} />
                </span>
              ) : application.rating_avg > 0 ? (
                <Fragment>
                  <span style={{ display: 'block' }}>
                    <Stars starRating={application.rating_avg} />
                  </span>
                  <span style={{ marginLeft: '100px', fontSize: '0.7em' }}>
                    {Math.round(application.rating_avg * 10) / 10} / 5 by{' '}
                    {Math.round(application.rating_user)} user
                    {application.rating_user > 1 && 's'}
                  </span>
                </Fragment>
              ) : (
                <span>[Not yet rated]</span>
              )}
              {application.editor_rating && (
                <Stars rating={application.editor_rating} />
              )}
            </Item.Content>
            <Item.Description style={{ marginTop: 25, fontSize: '1.2em' }}>
              {application.intro && parse(application.intro)}
            </Item.Description>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          {application.body && (
            <Item.Description style={{ fontSize: '1.2em' }}>
              {application.body && parse(application.body)}
            </Item.Description>
          )}
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16}>
            <a href={url} target='_blank' rel='noopener noreferrer'>
              <Button
                floated='right'
                content={`Visit ${application.title}`}
                color='blue'
              />
            </a>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column
            width={16}
            style={{ textAlign: 'right', fontSize: '1em' }}
          >
            {/* <ButtonLink content='Suggest an Edit' onClick={openSuggestion} /> |{' '} */}
            <ButtonLink onClick={() => reportLink(application.id)}>
              Report Broken Link
            </ButtonLink>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Fragment>
  );
}
